import { Injectable, Optional } from '@angular/core';
import { isToast, Toast, ToastType } from './toast.model';

@Injectable()
export class ToastService {

  toasts: Toast[] = [];

  constructor() { }

  toast(item: Toast | Toast[] | string, type?: ToastType, delay: number = 6000): Toast | Toast[] {
    if (item instanceof Array) {
      return item.map( i => this.toast(i)) as Toast[];
    } else if (isToast(item)) {
      return this.toast(item.description, item.type);
    } else {
      const toast: Toast = {description: item.toString(), type};
      this.toasts.push(toast);
      if (delay > 0) {
        setTimeout( () => {
          this.demiss(toast);
        }, delay);
      }
      return toast;
    }
  }

  demiss(item: Toast | Toast[]) {
    if (item instanceof Array) {
      item.forEach( i => this.demiss(i));
    } else {
      const index = this.toasts.indexOf(item);
      if (index != -1) {
        this.toasts.splice(
          this.toasts.indexOf(item),
          1
        );
      }
    }
  }

}
